import router from '@/router';
import store from '@/store';

const utils = {
  getBreakpointsMap() {
    let mapString = getComputedStyle(document.head).getPropertyValue('font-family');
    mapString = mapString.replace('/map-to-JSON((', '');
    mapString = mapString.replace('))/', '');
    const mapArray = mapString.split(',');
    const map = new Map();
    mapArray.forEach((b) => {
      const s = b.split(':');
      map.set(s[0].replace(/["]/gi, '').trim(), parseInt(s[1].replace('px', ''), 10));
    });
    return map;
  },
  screenIsUntil(breakpoint) {
    const map = utils.getBreakpointsMap();
    return window.innerWidth < map.get(breakpoint);
  },
  isTouchDevice() {
    return window.matchMedia('(pointer: coarse) and (hover: none)').matches;
  },
  setPageMeta() {
    let title = '';
    if (store.state.currentPageId === 'portfolio' && store.state.currentPageChildId) {
      const project = store.state.pages[store.state.currentPageId].childrens[store.state.currentPageChildId].structure[store.state.lang];
      const keys = Object.keys(project);
      const details = keys.find(k => project[k].component === 'ProjectDetails');
      title = project[details].data.name;
    } else {
      title = router.history.current.name;
    }
    document.title = `Pelizzari Studio ⏤ ${title}`;
    const { description, descriptionEn, descriptionRu } = store.state.pages[store.state.currentPageId];
    let actualDescription = description;
    if (store.state.lang === 'en') actualDescription = descriptionEn;
    if (store.state.lang === 'ru') actualDescription = descriptionRu;
    document.querySelector('meta[name="description"]').setAttribute('content', actualDescription);
  },
  isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    let isSafari = false;
    isSafari = /constructor/i.test(window.HTMLElement) ||
              (p => p.toString() === '[object SafariRemoteNotification]')(!window.safari || window.safari.pushNotification);
    isSafari = (
      isSafari ||
      ((ua.indexOf('safari') !== -1) &&
      (!(ua.indexOf('chrome') !== -1) &&
      (ua.indexOf('version/') !== -1)))
    );
    return isSafari;
  },
  isInRect(mouse, rect) {
    return (
      mouse.x > rect.left &&
      mouse.y > rect.top &&
      mouse.x < rect.right &&
      mouse.y < rect.bottom
    );
  },
  zeroFill(number) {
    if (number < 10) return `0${number}`;
    return number;
  },
};

export default utils;
